import React from 'react';
import { formatPeriodLabel } from '../submissions/periodFormat';

const completion = (kpis) => {
  const list = kpis || [];
  const met = list.filter((k) => Number(k.current_value) >= Number(k.target_value)).length;
  return `${met}/${list.length} targets`;
};

export function ApprovedKpiList({ rows, page, pageCount, onPage, onDetail }) {
  if (!rows || rows.length === 0) {
    return <p className="submissions-empty">No approved KPI submissions match these filters.</p>;
  }
  return (
    <>
      <table className="submissions-table">
        <thead>
          <tr><th>Employee</th><th>Period</th><th>Completion</th><th>Country</th><th>Approved by</th><th>Team Lead</th><th></th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.submitter?.name || '—'}</td>
              <td>{formatPeriodLabel(r.period, r.period_start, r.period_end)}</td>
              <td>{completion(r.kpis)}</td>
              <td>{r.submitter?.countries?.name || '—'}</td>
              <td>{r.approvedByName || '—'}</td><td>{r.teamLeadName || '—'}</td>
              <td><button type="button" className="btn-edit" onClick={() => onDetail(r)}>Details</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {pageCount > 1 && (
        <div className="pagination">
          <button type="button" className="btn-secondary" disabled={page === 0} onClick={() => onPage(page - 1)}>Prev</button>
          <span>Page {page + 1} of {pageCount}</span>
          <button type="button" className="btn-secondary" disabled={page + 1 >= pageCount} onClick={() => onPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
